// Per-item accent, derived deterministically from the item id. References theme colors (via
// Bootstrap CSS variables) so it stays in sync with custom.scss rather than hardcoding hex.
const ACCENTS = [
  'var(--bs-primary)',
  'var(--bs-danger)',
  'var(--bs-warning)',
  'var(--bs-success)',
  'var(--bs-info)'
]

// Ids are UUID strings, so a numeric cast is always NaN. Hash the string to a stable non-negative
// integer so accent/chart-variant selection actually distributes across items.
export const hashId = (id) => {
  const str = String(id ?? '')
  let hash = 0
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0
  }
  return Math.abs(hash)
}

export const accentForId = (id) => ACCENTS[hashId(id) % ACCENTS.length]

// Only a Report carries a color. A View and a Sample are source material — the data a report is
// built from — and coloring all three made a mixed grid read as one undifferentiated wall with
// nothing marking the authored document among its inputs.
//
// The dark token rather than `secondary`: these marks are small (a 24px avatar, 1px table rules on
// a light band) and the mid-grey sat close enough to the surface that they stopped reading at all.
// Dark is still colorless, which is the part that matters.
export const NEUTRAL_INK = 'var(--bs-dark)'

// The owner avatar specifically: grey, not the item's accent and not the near-black ink. It says
// who owns the card, which is not a property of the card's content.
export const OWNER_AVATAR_BG = 'var(--bs-gray-600)'

export const accentForItem = (type, id) => (type === 'report' ? accentForId(id) : NEUTRAL_INK)

// Offset the hash so an item's chart style and accent aren't perfectly correlated.
export const chartVariantForId = (id, variantCount) => (hashId(id) + 2) % variantCount

export const initials = (name) => {
  if (!name) return '?'
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}
